import { useState } from "react";
import { useAuth } from "@/features/auth/AuthContext";
import {
  LGoButton,
  LGoCard,
  LGoCardContent,
  LGoCardDescription,
  LGoCardHeader,
  LGoCardTitle,
} from "@/ui/branded";

export function CustomerAccountNotice() {
  const { signOut } = useAuth();
  const [isSigningOut, setIsSigningOut] = useState(false);

  const leave = async () => {
    setIsSigningOut(true);
    await signOut();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center space-y-1">
          <h1 className="font-display text-6xl font-semibold tracking-[-0.05em] text-foreground">
            LastGO<span className="text-primary">.</span>
          </h1>
          <p className="text-sm uppercase tracking-[0.2em] text-muted-foreground">
            Partnerský portál
          </p>
        </div>

        <LGoCard variant="raised" padding="lg">
          <LGoCardHeader>
            <LGoCardTitle className="text-2xl">Tento účet patří do aplikace LastGO</LGoCardTitle>
            <LGoCardDescription>
              Přihlásili jste se účtem zákaznické aplikace LastGO. Partnerský portál je jen pro
              provozovny — partnerský účet vznikne až registrací s přístupovým kódem, který vaše
              provozovna od nás dostala.
            </LGoCardDescription>
          </LGoCardHeader>
          <LGoCardContent>
            <LGoButton
              variant="primary"
              className="w-full"
              loading={isSigningOut}
              onClick={leave}
            >
              Odhlásit se
            </LGoButton>
          </LGoCardContent>
        </LGoCard>
      </div>
    </div>
  );
}
